import type { Capabilities } from '@jerome2/shared';
import { useStore } from '../lib/store.ts';
import { app } from '../state/app.ts';

// Of spraak kan: dicteren (Scribe) en voorlezen (ElevenLabs) werken alleen als de server een sleutel heeft.
// Zolang de mogelijkheden nog niet geladen zijn, of een oudere server ze niet meldt, gaan we uit van "kan wel":
// liever één nette foutmelding bij het proberen dan knoppen die onterecht gedempt staan.

/** Titel (en tooltip) van een gedempte microfoonknop. */
export const VOICE_OFF_TITLE = 'Spraak staat uit: geen ElevenLabs-sleutel';
/** Titel (en tooltip) van een gedempte voorleesknop. */
export const SPEECH_OFF_TITLE = 'Voorlezen staat uit: geen ElevenLabs-sleutel';

export interface VoiceCapability {
  dictation: boolean;
  speech: boolean;
  /** De server heeft het echt gemeld (anders is dit de aanname). */
  known: boolean;
}

export function voiceCapability(caps: Capabilities | null): VoiceCapability {
  const voice = caps?.voice;
  if (!voice) return { dictation: true, speech: true, known: false };
  return { dictation: voice.dictation, speech: voice.speech, known: true };
}

export function useVoiceCapability(): VoiceCapability {
  const caps = useStore(app, (s) => s.capabilities);
  return voiceCapability(caps);
}
